<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'mainauth.notFound.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
<div class="not-found-container">
  <h1>{{ 'mainauth.notFound.heading' | translate }}</h1>
  <p>{{ 'mainauth.notFound.message' | translate }}</p>
  <button routerLink="/home">{{ 'mainauth.notFound.home' | translate }}</button>
</div>
</ion-content>
